import React, { useState } from 'react';
import request from '@/services/request.service';
import { toFormData } from '@/utils/convert.util';
import { getLocaleWordContent } from '@/utils/language.util';
// import { getServerMessage } from '@/utils/massage.util';

export default function ChangePassword() {
    const [old_pwd, setOld] = useState('');
    const [new_pwd, setNew] = useState('');
    const [confirm, setConfirm] = useState('');

    const handleChange = (e) => {
        if (e) e.preventDefault();

        //console.log("handleChange:", e.target.name);
        if (e.target.name === 'old_pwd') {
            setOld(e.target.value);
        } else if (e.target.name === 'new_pwd') {
            setNew(e.target.value);
        } else if (e.target.name === 'confirm') {
            setConfirm(e.target.value);
        }
    };

    const handleSubmit = () => {
        if (new_pwd === confirm) {
            _submitData();
        } else {
            alert("It's different new password from confirm password.");
        }
    };

    const _submitData = async () => {
        const param = { old_pwd, new_pwd, confirm, type: '1' };
        const rsp = await request
            .post('/api/account/user_update.php', toFormData(param))
            .then((response) => response.data);
        if (rsp.result < 0) {
            alert(rsp.msg);
        } else {
            alert(rsp.msg);
            setOld('');
            setNew('');
            setConfirm('');
            window.location.reload();
            return rsp;
        }
    };

    return (
        <div className="change_box">
            <h2 className="strong">{getLocaleWordContent('비밀번호변경')}</h2>
            <form className="inputbox">
                <div className="input_form">
                    <p className="title">{getLocaleWordContent('기존 비밀번호')}</p>
                    <input
                        type="text"
                        name="old_pwd"
                        onChange={handleChange}
                        className="input01"
                        placeholder={getLocaleWordContent('기존 비밀번호 입력해주세요.')}
                    />
                </div>
                <div className="input_form">
                    <p className="title">{getLocaleWordContent('새로운 비밀번호')}</p>
                    <input
                        type="text"
                        name="new_pwd"
                        onChange={handleChange}
                        className="input01"
                        placeholder={getLocaleWordContent('새 비밀번호 입력해주세요.')}
                    />
                </div>
                <div className="input_form">
                    <p className="title">{getLocaleWordContent('새로운 비밀번호 확인')}</p>
                    <input
                        type="text"
                        name="confirm"
                        onChange={handleChange}
                        className="input01"
                        placeholder={getLocaleWordContent('새비밀번호 다시 입력하세요.')}
                    />
                </div>
                <div className="sub_btn_box">
                    <input type="button" onClick={handleSubmit} className="btn01" defaultValue={getLocaleWordContent('변경하기')} />
                </div>
            </form>
        </div>
    );
}
